import {connect} from 'react-redux';

import {getAvailableCategories} from '../../../general/selectors';

import Header from './Header';
import Body from './Body';

const Matrix = ({categories}) => (
    <table className="component-matrix">
        <Header />
        {categories.map(category => <Body {...category} key={category.id} />)}
    </table>
);

const mapStateToProps = state => ({
    categories: getAvailableCategories(state),
});

export default connect(mapStateToProps)(Matrix);
